import {createSlice} from '@reduxjs/toolkit';

export interface UserState {
  isError: boolean;
  isSuccess: boolean;
  isLoading: boolean;
  message: string;
  isLogoutRequired: boolean;
  isSessionRefreshRequired: boolean;
}

// Initial state
const initialState: UserState = {
  isError: false,
  isSuccess: false,
  isLoading: false,
  isLogoutRequired: false,
  isSessionRefreshRequired: false,
  message: '',
};

// Slice
export const authSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    resetUserState: () => initialState,
    setIsLogoutRequired: (state, action) => {
      state.isLogoutRequired = action.payload;
    },
    setIsSessionRefreshRequired: (state, action) => {
      state.isSessionRefreshRequired = action.payload;
    },
  },
});

export const {
  resetUserState,
  setIsLogoutRequired,
  setIsSessionRefreshRequired,
} = authSlice.actions;

export default authSlice.reducer;
